import { wrap } from "../../lib/ui.ts";

export function Wrap({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={className ? `${wrap} ${className}` : wrap}>{children}</div>;
}
